import Permission from "Components/Common/Permission";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import * as moment from "moment";
import UpdateClassifiedInformation from "./UpdateClassifiedInformation";
import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";

const ClassifiedInformation = ({ person }: { person: any }) => {
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const showUpdateModal = () => {
    setIsUpdateModalOpen(true);
  };
  const { userProfile } = useProfile();
  const hasClassifiedPermission = isAllowed(userProfile?.permissions, [
    { resource: "person", action: "updateClassifiedInformation" },
  ]);
  const classifiedList = person?.classifiedInformation || [];
  return (
    <Card>
      <CardHeader className="d-flex align-items-center">
        <div className="text-muted flex-grow-1 d-flex align-items-center">
          <h6 className="mb-0 fw-semibold text-uppercase">
            Classified Information
            <small
              color="light"
              className="badge bg-primary-subtle align-bottom ms-1 text-primary"
            >
              {(person?.classifiedInformation || []).length || 0}
            </small>
          </h6>
        </div>
        <div className="flex-shrink-0 d-flex align-items-center">
          <Permission
            resource={"person"}
            action={"updateClassifiedInformation"}
          >
            <Link
              to="#"
              onClick={(e) => {
                e.stopPropagation(); // Prevent collapse toggle on edit click
                showUpdateModal();
              }}
              className="link-primary link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover me-3"
            >
              <i className="ri-pencil-line"></i> Edit
            </Link>
          </Permission>
        </div>
      </CardHeader>
      <CardBody className="card-body ">
        {classifiedList.length === 0 && (
          <div className="text-muted text-center py-3">
            No classified information
          </div>
        )}
        {classifiedList.length > 0 && hasClassifiedPermission && (
          <>
            {classifiedList.map((info: any, index: number) => (
              <Card
                className="profile-project-card shadow-none profile-project-danger mb-3 material-shadow"
                key={index}
              >
                <CardBody className="p-4">
                  <Row>
                    <Col xs={6} md={4}>
                      <div className="d-flex mt-0">
                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                          <div className="avatar-title bg-light rounded-circle fs-16 text-primary material-shadow">
                            <i className="ri-shield-keyhole-line"></i>
                          </div>
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                          <p className="mb-1">
                            Type of Classified Information :
                          </p>
                          <h6 className="text-truncate mb-0">
                            {info?.type?.name || "Not Provided"}
                          </h6>
                        </div>
                      </div>
                    </Col>

                    <Col xs={6} md={4}>
                      <div className="d-flex mt-0">
                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                          <div className="avatar-title bg-light rounded-circle fs-16 text-primary material-shadow">
                            <i className="ri-time-line"></i>
                          </div>
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                          <p className="mb-0">Date :</p>
                          <Link to="#" className="fw-semibold">
                            {info?.date
                              ? moment(new Date(info?.date)).format("DD MMM, Y")
                              : "Not Provided"}
                          </Link>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={4}>
                      <div className="d-flex mt-0">
                        <div className="flex-shrink-0 avatar-xs align-self-center me-3">
                          <div className="avatar-title bg-light rounded-circle fs-16 text-primary material-shadow">
                            <i className="ri-global-line"></i>
                          </div>
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                          <p className="mb-0">Reporting Agency :</p>
                          <Link to="#" className="fw-semibold">
                            {info?.reportingAgency?.name || "Not Provided"}
                          </Link>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4 mt-md-4 pt-1">
                      <h6 className="mb-1">Description or Reason:</h6>
                      <p>{info?.description || "Not Provided"}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </>
        )}
        {classifiedList.length > 0 && !hasClassifiedPermission && (
          <Alert color="warning" className="material-shadow">
            Classified information is available for this person. Please
            <a
              href="mailto:cims.somalia@undp.org"
              className="ms-1 text-reset text-decoration-underline"
              onClick={(e) => {
                e.stopPropagation();
                window.location.href = "mailto:cims.somalia@undp.org";
              }}
            >
              contact the RMU
            </a>{" "}
            for more information.
          </Alert>
        )}
      </CardBody>
      <UpdateClassifiedInformation
        toggle={() => setIsUpdateModalOpen((state) => !state)}
        isModalOpen={isUpdateModalOpen}
        person={person}
      />
    </Card>
  );
};

export default ClassifiedInformation;
